import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

const SnackbarAction = ({ closeSnackbarHandler }) => (
  <>
    <CloseIcon
      sx={{ cursor: 'pointer' }}
      fontSize="small"
      onClick={closeSnackbarHandler}
    />
  </>
);

export default SnackbarAction;
